// English
export default {
	common: {
		requestFailed: 'Request failed',
		needLogin: 'You need to log in',
		accountLoggedOut: 'Account logged out',
		confirm: 'Confirm',
		cancel: 'Cancel',
	},
	nav: {
		home: 'Home',
		list: 'List',
		game: 'Verified',
		video: 'Movies',
		mine: 'Me',
	},

	route: {
		home: 'Home',
		choose: 'Choose companion',
		list: 'Companion list',
		profile: 'Detail info',
		mine: 'Mine',
		video: 'Video',
		game: 'Game',
		login: 'Login',
		register: 'Register',
		serviceOnline: 'Online service',
		servicePage: 'Online service',
		setting: 'Settings',
		infomation: 'Basic information',
		setname: 'Edit real name',
		setsex: 'Edit gender',
		setPayPassword: 'Manage payment password',
		setLoginPassword: 'Manage login password',
		lottery: 'Detail page',
		notice: 'Notice',
		playVideo: 'Play video',
		setbank: 'Enter receiving card info',
		bindCard: 'Bind bank card',
		withdraw: 'Withdraw',
		personalreport: 'Personal report',
		withdrawRecord: 'Withdraw history',
		gameRecord: 'Task history',
	},
	page: {
		login: {
			title: 'Login',
			usernamePlaceholder: 'Enter username',
			passwordPlaceholder: 'Enter password',
			forgotPassword: 'Forgot password?',
			registerPrompt: 'No account yet? Register now',
			loginBtn: 'Login',
			enterUsername: 'Please enter username!',
			enterPassword: 'Please enter password!',
		},
		mine: {
			recharge: 'Recharge',
			withdraw: 'Withdraw',
			myWallet: 'My wallet',
			detail: 'Detail',
			balance: 'Balance',
			personalReport: 'Personal report',
			accountDetail: 'Account detail',
			taskRecord: 'Task record',
			profileCenter: 'Profile center',
			notice: 'Notice',
			onlineService: 'Online service',
			refreshSuccess: 'Refreshed',
			exitTaskWarn: 'Please complete the task before leaving',
			rechargeContactService: 'Please contact customer service to recharge',
			setBankCardFirst: 'Please set receiving card info first!',
			functionDisabled: 'Function disabled!',
			guestUsername: 'Login / Register',
			guestSubtitle: 'Log in to enjoy more services!',
		},
		setting: {
			navTitle: 'Settings',
			basicInfoSetting: 'Basic info settings',
			loginPassword: 'Login password',
			payPassword: 'Payment password',
			payPasswordSet: 'Set',
			payPasswordUnset: 'Not set',
			logout: 'Log out',
			payPasswordAlreadySet: 'Withdrawal password is set; please contact customer service to change it',
			language: 'Switch language',
		},
		infomation: {
			navTitle: 'Basic information',
			avatar: 'Avatar',
			selectAvatar: 'Select avatar',
			realName: 'Real name',
			notSet: 'Not set',
			gender: 'Gender',
			genderUndefined: 'Undefined',
			male: 'Male',
			female: 'Female',
			bankBinding: 'Bank binding',
			linked: 'Linked',
			none: 'None',
		},
		setname: {
			navTitle: 'Edit real name',
			save: 'Save',
			name: 'Name',
			namePlaceholder: 'Please enter real name',
			nameWarn: 'To ensure account security, the real name must match the name on the linked bank card',
			dontSetAgain: 'Please do not set again!',
			enterName: 'Please enter name!',
		},
		setsex: {
			navTitle: 'Edit gender',
			male: 'Male',
			female: 'Female',
		},
		setPayPassword: {
			navTitle: 'Set payment password',
			enterPassword: 'Enter payment password',
			confirmPassword: 'Re-enter payment password',
			fillComplete: 'Please fill in completely',
			passwordMismatch: 'Passwords do not match!',
		},
		setLoginPassword: {
			navTitle: 'Change login password',
			save: 'Save',
			oldPassword: 'Old password',
			oldPasswordPlaceholder: 'Please enter old password',
			newPassword: 'New password',
			newPasswordPlaceholder: 'Please enter new password',
			confirmPasswordPlaceholder: 'Please re-enter new password',
			fillComplete: 'Please fill in all fields!',
			passwordMismatch: 'The two passwords do not match',
		},
		notice: {
			navTitle: 'System notice',
			refreshSuccess: 'Refreshed',
		},
		serviceOnline: {
			navTitle: 'Online service',
			contact: 'Contact',
			serviceHours: 'Serving you 24/7',
		},
		servicePage: {
			navTitle: 'Customer service',
		},
		withdraw: {
			navTitle: 'Withdraw center',
			history: 'Withdraw history',
			amount: 'Withdraw amount',
			all: 'All',
			limit: 'Withdraw limit',
			limitPerTransaction: '1. Per transaction limit: Min {min} , Max {max} ',
			limitPerDay: '2. Withdraw times: Max {num} times per day',
			transferTime: '3. Transfer time: Usually about 5 minutes, fastest within 2 minutes',
			balanceLabel: 'Balance:',
			withdrawNow: 'Withdraw now',
			enterCorrectAmount: 'Please enter the correct amount',
		},
		withdrawRecord: {
			navTitle: 'Withdraw history',
			noData: 'No data!',
			amount: 'Amount:',
			info: 'Info:',
			submitTime: 'Submit time:',
			auditTime: 'Audit time:',
			refreshSuccess: 'Refreshed',
		},
		bindCard: {
			navTitle: 'Enter receiving card info',
			label: 'Please enter your receiving card info',
			accountNumber: 'Account number',
			accountPlaceholder: 'Please enter bank account number',
			bank: 'Bank',
			bankPlaceholder: 'Please select bank',
			warn: 'Dear user, to ensure your financial security, please bind your real name and set a withdrawal password. If the name does not match the account name, you will not be able to withdraw.',
			confirmBind: 'Confirm binding',
			enterCardNumber: 'Please enter card number!',
			selectBank: 'Please select bank!',
		},
		setbank: {
			navTitle: 'Card info',
			addCard: 'Add withdrawal card info',
			tip: 'Tip: Please bind a large commercial bank. To change, please contact online service',
			setNameFirst: 'Please set your name before binding bank card!',
			setPayPasswordFirst: 'Please set withdrawal password before binding bank card!',
		},
		personalreport: {
			navTitle: 'Personal report',
			profitTitle: 'Profit',
			profitFormula: 'Profit formula: Win amount - Bet amount',
			taskMoney: 'Bet amount',
			rechargeMoney: 'Recharge amount',
			withdrawMoney: 'Withdraw amount',
			winMoney: 'Win amount',
		},
		gameRecord: {
			navTitle: 'Task history',
			noData: 'No data!',
			betAmount: 'Bet amount:',
			betTime: 'Bet time:',
			updateTime: 'Update time:',
			refreshSuccess: 'Refreshed',
			kim: 'Metal',
			moc: 'Wood',
			thuy: 'Water',
			hoa: 'Fire',
		},
		home: {
			recommendTask: 'Recommended tasks',
			viewMore: 'View more',
			popularRanking: 'Popular ranking',
			hotRecommend: 'Hot recommend',
			playCount: 'Plays:',
			loadingData: 'Loading data...',
			refreshSuccess: 'Refreshed',
		},
		choose: {
			navTitle: 'Want to date?',
			city: 'City',
			cityDesc: 'community is the top reputable platform, sharing the most reliable information. We promise a reputable, healthy and privacy-protected place for customers.',
			processAndPrice: 'Process and price',
			processDesc: 'This website provides peripheral, business companion and emotional related services in the same city. To protect each user\'s privacy, customers can only join by contacting reception staff or senior members of the platform.',
			resourcesTitle: 'What resources are available?',
			resourcesContent: 'You can find famous artists, models, flight attendants, young models, college students, nothing is impossible with this platform',
			serviceScopeTitle: 'Service scope?',
			serviceScopeContent1: 'Free dating in the same city, covering all locations nationwide, present in major cities, can also be arranged by contacting reception staff.',
			serviceScopeContent2: 'This website provides peripheral, business companion and emotional related services in the same city. To protect each user\'s privacy, customers can only join by contacting reception staff or senior members of the platform.',
		},
		list: {
			refreshSuccess: 'Refreshed',
		},
		profile: {
			navTitle: 'Choose',
			bookAppointment: 'Book appointment',
			contactConsultant: 'Please contact consultant or receptionist',
		},
		video: {
			navTitle: 'Cinema',
			noMore: 'No more',
			playCount: 'Plays:',
			refreshSuccess: 'Refreshed',
		},
		playVideo: {
			playCount: 'plays',
			hotRecommend: 'Hot recommend',
			rechargeToWatch: 'Please recharge to watch video!',
		},
		game: {
			navTitle: 'Voting Hall',
			all: 'All',
			refreshSuccess: 'Refreshed',
		},
		register: {
			title: 'Register',
			usernamePlaceholder: 'Enter username (6-12 letters or numbers)',
			passwordPlaceholder: 'Enter password (6-12 letters or numbers)',
			codePlaceholder: 'Enter invitation code',
			agreementText: 'I have read and agree to the "Account Agreement" terms',
			registerBtn: 'Register',
			enterUsername: 'Please enter username!',
			enterPassword: 'Please enter password!',
			enterCode: 'Please enter invitation code!',
			agreeTerms: 'Please agree to the terms below!',
		},
		lottery: {
			taskHistory: 'Task history',
			rules: 'Game rules',
			playHint: 'Play hint',
			playHintDetail: 'Select numbers from available forms and values to bet',
			prizeGuide: 'Prize guide',
			prizeGuideDetail: 'Sum of three winning numbers 11-18 is large; 3-10 is small;',
			betExample: 'Bet example',
			betExampleDetail: 'Bet example: small. Lottery result: 123, means winning small',
			taskOrder: 'Task order',
			availableBalance: 'Balance',
			currency: 'Score',
			submit: 'Submit',
			currentChoice: 'Current choice:',
			betAmount: 'Bet amount:',
			enterAmount: 'Enter amount',
			selected: 'Selected',
			total: 'Total',
			orderDetail: '1 x {money}đ = {money}',
			clearOrder: 'Clear order',
			confirmSubmit: 'Confirm submit',
			periodNumber: 'Period number',
			resultNumber: 'Result number',
			notSelected: 'Not selected',
			invalidAmount: 'Invalid amount!',
			selectNumber: 'Please select numbers!',
			enterAmountWarn: 'Please enter amount!',
			insufficientBalance: 'Insufficient balance, please contact customer service to recharge!',
			refreshSuccess: 'Refreshed',
			contactAdminForTask: 'Please contact admin to get this task!',
			lotteryResultPeriod: 'Lottery result, period: {period}',
			"lotterynow": "Current",
			    "lotterying": "Voting in progress",
			    "lottery_da": "Rocket",
			    "lottery_xiao": "Heart",
			    "lottery_dan": "Yacht",
			    "lottery_shuang": "Rose",
			    "lottery_piao": "Ticket",
			    "lottery_his": "History",
			    "lottery_log": "Record",
			    "lottery_sec": "Vote selection"
		
		},
		ordlan: {
			PopularMembers:'Popular Members',
			Rating:'Rating',
			AppointmentRequest:'Appointment Request',
			PersonalVideoVerification:'Personal Video Verification',
			IdentityVerification:'Identity Verification',
			ManagerProfile:'Manager Profile',
			ServiceArea:'Service Area',
			TravelAvailable :'Travel Available',
			Yes:'Yes',
			help:'Help',
			AgencyBooking:'Agency Booking',
			More:'More',
			
		}
	},
}
